import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoDinamikKesit } from '../FikoDinamikKesit';
import { FikoDialogService } from '../../../../fiko-dialog-core/fiko-dialog.service';
import { DuzlemHareketDialogComponent } from '../duzlem-hareket-dialog/duzlem-hareket-dialog.component';
import * as THREE from 'three';

@Component({
    selector: 'fikoyt-duzlem-kontrol',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './duzlem-kontrol.component.html',
    styleUrls: ['./duzlem-kontrol.component.scss']
})
export class DuzlemKontrolComponent {
    @Input() dinamikKesit!: FikoDinamikKesit;

    // Kesit düzlemleri
    kesitDuzlemleri: any[] = [];
    aktifDuzlemIndex: number = 0;

    constructor(
        public CD: ChangeDetectorRef,
        private dialogService: FikoDialogService
    ) {}

    ngOnInit() {
        this.guncelleDuzlemListesi();
    }

    guncelleDuzlemListesi() {
        this.kesitDuzlemleri = this.dinamikKesit.kesitDuzlemleri.map((plane, index) => ({
            id: index,
            isim: `Düzlem ${index + 1}`,
            plane: plane
        }));
        this.aktifDuzlemIndex = this.dinamikKesit.aktifDuzlemIndex;
    }

    aktifDuzlemDegistir(index: number) {
        this.dinamikKesit.aktifDuzlemDegistir(index);
        this.aktifDuzlemIndex = index;
        this.CD.detectChanges();
    }

    yeniDuzlemEkle() {
        this.dinamikKesit.yeniKesitDuzlemiEkle();
        this.guncelleDuzlemListesi();
        this.CD.detectChanges();
    }

    duzlemSil(index: number) {
        this.dinamikKesit.kesitDuzlemiSil(index);
        this.guncelleDuzlemListesi();
        this.CD.detectChanges();
    }

    // Hareket ve dönme dialog'unu aç
    hareketDialogAc() {
        this.dialogService.ac({
            bilesen: DuzlemHareketDialogComponent,
            parametreler: {
                dinamikKesit: this.dinamikKesit
            },
            ayarlar: {
                baslik: 'Düzlem Hareket ve Dönme Kontrolleri',
                genislik: '280px',
                yukseklik: 'auto'
            }
        });
    }

    // Kesit inverse (ters çevir)
    duzlemInverse() {
        this.dinamikKesit.duzlemInverse();
        this.CD.detectChanges();
    }

    // Yüzey seçimi toggle
    yuzeySecimToggle() {
        if (this.dinamikKesit.yuzeySecimAktif) {
            this.dinamikKesit.yuzeySecimDurdur();
        } else {
            this.dinamikKesit.yuzeySecimBaslat();
        }
        this.CD.detectChanges();
    }

    // Düzlemi yüzey merkezine taşı
    duzlemYuzeyMerkezineTasi() {
        this.dinamikKesit.duzlemYuzeyMerkezineTasi();
        this.CD.detectChanges();
    }

    // Düzlemi sahne merkezine taşı
    duzlemSahneMerkezineTasi() {
        this.dinamikKesit.duzlemSahneMerkezineTasi();
        this.CD.detectChanges();
    }

    // Sıfırla
    tumDuzlemleriSifirla() {
        this.dinamikKesit.kesitDuzlemleri.forEach((_, index) => {
            this.dinamikKesit.kesitDuzlemiSil(0);
        });
        this.dinamikKesit.yeniKesitDuzlemiEkle();
        this.guncelleDuzlemListesi();
        this.CD.detectChanges();
    }

    // Görünürlük toggle metodları
    halkaGorunurlukToggle() {
        this.dinamikKesit.halkaGorunurlukToggle();
        this.CD.detectChanges();
    }

    gridGorunurlukToggle() {
        this.dinamikKesit.gridGorunurlukToggle();
        this.CD.detectChanges();
    }

    kesitCizgisiGorunurlukToggle() {
        this.dinamikKesit.kesitCizgisiGorunurlukToggle();
        this.CD.detectChanges();
    }

    konturAktar(format: 'dxf' | 'svg') {
        const ok = this.dinamikKesit.konturDisariAktar(format);
        if (!ok) alert('Dışa aktarılacak kesit konturu bulunamadı. Önce bir kesit oluşturun.');
    }

    okGorunurlukToggle() {
        this.dinamikKesit.okGorunurlukToggle();
        this.CD.detectChanges();
    }

    eksenGorunurlukToggle() {
        this.dinamikKesit.eksenGorunurlukToggle();
        this.CD.detectChanges();
    }
}
